import { useEffect, useState } from 'react';
import { csrfTokenCall } from 'wisestep-api';

const useGetCSRFToken = () => {
  const [CSRFToken, setCSRFToken] = useState<string>('');
  const [authorizationToken, setAuthorizationToken] = useState<string>('');
  useEffect(() => {
    const getToken = async () => {
      const res = await csrfTokenCall();
      const token = res.config.headers?.['X-XSRF-TOKEN'];
      const auth = res.config.headers?.['Authorization'];
      setCSRFToken(token ?? '');
      setAuthorizationToken(auth ?? '');
    };
    getToken();
  }, []);

  return { CSRFToken, authorizationToken };
};

export default useGetCSRFToken;
